import { useContext, useState } from 'react'
import { Navigate, useNavigate } from 'react-router-dom'
import {
  Alert,
  Backdrop,
  Box,
  Button,
  CircularProgress,
  Grid,
  Paper,
  Snackbar,
  TextField,
  Typography,
} from '@mui/material'
import { Context } from '../../context/AuthContext'
import { userLogin } from '../../services/api'
import { mensagemDeErro } from '../../services/apiClient'
import bgImage from '../../assets/login.png'
import bihands from '../../assets/Ativo-3@4x-bihands-300x64.png'
import infoiot from '../../assets/info.png'

const LoginForm = () => {
  const { handleLogin, authenticated, loading: contextLoading } = useContext(Context)
  const navigate = useNavigate()

  const subdomain = window.location.hostname.split('.')[0]

  const [values, setValues] = useState({ email: '', password: '' })
  const [errors, setErrors] = useState({})
  const [errorLogin, setErrorLogin] = useState('')
  const [loading, setLoading] = useState(false)

  if (!contextLoading && authenticated) {
    return <Navigate to="/dashboard" replace />
  }

  const handleChange = event => {
    const { name, value } = event.target
    setValues(current => ({ ...current, [name]: value }))
    setErrors(current => ({ ...current, [name]: '' }))
  }

  const validate = () => {
    const nextErrors = {}
    if (!values.email) nextErrors.email = 'Insira seu e-mail'
    if (!values.password) nextErrors.password = 'Insira sua senha'
    setErrors(nextErrors)
    return Object.keys(nextErrors).length === 0
  }

  const handleSubmit = async event => {
    event.preventDefault()
    if (!validate()) return

    setLoading(true)
    try {
      const response = await userLogin(values)
      await handleLogin(response)
      navigate('/dashboard')
    } catch (err) {
      localStorage.removeItem('token')
      setErrorLogin(mensagemDeErro(err, 'Verifique seu e-mail e senha'))
      setLoading(false)
    }
  }

  const logo = subdomain === 'rfidinfoiot' ? infoiot : bihands

  const form = (
    <>
      <Box sx={{ width: '90%', textAlign: 'center' }} component="form" onSubmit={handleSubmit}>
        <Box my={2}>
          <Box component="img" src={logo} alt="Bihands" sx={{ width: '100%', maxWidth: 350 }} />
        </Box>
        <Typography variant="subtitle1" color="text.secondary" sx={{ mb: 1 }}>
          Controle de Produção
        </Typography>

        <Box>
          <TextField
            margin="normal"
            required
            fullWidth
            id="email"
            name="email"
            label="E-mail"
            autoComplete="email"
            autoFocus
            value={values.email}
            onChange={handleChange}
          />
          {errors.email && (
            <Typography variant="body2" color="error">
              {errors.email}
            </Typography>
          )}
        </Box>

        <Box>
          <TextField
            margin="normal"
            required
            fullWidth
            id="password"
            name="password"
            label="Senha"
            type="password"
            autoComplete="current-password"
            value={values.password}
            onChange={handleChange}
          />
          {errors.password && (
            <Typography variant="body2" color="error">
              {errors.password}
            </Typography>
          )}
        </Box>

        <Button type="submit" variant="contained" sx={{ marginTop: '1rem' }} disabled={loading}>
          Acessar Conta
        </Button>
      </Box>
      <Button sx={{ mt: 2, fontSize: '.8em' }} onClick={() => navigate('/ForgotPassword')}>
        Esqueci minha senha
      </Button>
    </>
  )

  return (
    <Grid
      container
      component="main"
      sx={{
        width: '100%',
        height: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Snackbar
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        open={Boolean(errorLogin)}
        autoHideDuration={6000}
        onClose={() => setErrorLogin('')}
      >
        <Alert onClose={() => setErrorLogin('')} severity="error" sx={{ width: '100%' }}>
          {errorLogin}
        </Alert>
      </Snackbar>

      {/* Desktop */}
      <Box
        display={{ xs: 'none', md: 'flex' }}
        sx={{ width: '100%', height: '100%', alignItems: 'center', justifyContent: 'center' }}
      >
        <Box
          sx={{
            width: '65%',
            height: '100vh',
            backgroundImage: `url(${bgImage})`,
            backgroundSize: 'contain',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center center',
          }}
        />
        <Box
          sx={{
            width: '35%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          {form}
        </Box>
      </Box>

      {/* Mobile */}
      <Box
        display={{ xs: 'flex', md: 'none' }}
        sx={{
          width: '100%',
          height: '100%',
          alignItems: 'center',
          justifyContent: 'center',
          flexDirection: 'column',
        }}
      >
        <Paper
          elevation={3}
          sx={{
            width: '90%',
            padding: 2,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          {form}
        </Paper>
      </Box>

      <Backdrop sx={{ color: '#fff', zIndex: theme => theme.zIndex.drawer + 1 }} open={loading}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </Grid>
  )
}

export default LoginForm
